import RadioVolumeItem from "./RadioVolumeItem";
import VolumeLegend from "./VolumeLegend";
import { ALL_RADIOS } from "../../../../config/audio/radioConfig";
import { useContext } from "react";
import { audioContext } from "../../../contexts/AudioContext";

export default function RadioVolumeOverlay() {
	const { radioState } = useContext(audioContext);

	return (
		<div
			className="absolute top-0 right-0 text-white z-50 pointer-events-none m-2 bg-black/50 rounded-xl p-4 shadow-lg border-2 border-white/20 min-w-80 max-w-lg"
			style={{ fontFamily: '"Fredoka One", sans-serif' }}
		>
			<div className="font-bold mb-4 text-white text-xl">Radio Volumes</div>

			{ALL_RADIOS.map((radioName) => (
				<RadioVolumeItem
					key={radioName}
					radioName={radioName}
					radioState={radioState[radioName]}
				/>
			))}

			<VolumeLegend />
		</div>
	);
}
